import { render, staticRenderFns } from "./SiderBackgroundPicker.vue?vue&type=template&id=3e1536c4&scoped=true&"
import script from "./SiderBackgroundPicker.vue?vue&type=script&lang=js&"
export * from "./SiderBackgroundPicker.vue?vue&type=script&lang=js&"
import style0 from "./SiderBackgroundPicker.vue?vue&type=style&index=0&id=3e1536c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1536c4",
  null
  
)

export default component.exports